import React from "react";
import { Form, CheckBox, TextAreaBox } from "fw/forms";
import { Col, FormGroup, Row } from "react-bootstrap";
import { Label, Button } from "fw/components";
import { ContentBody, VeteranAppIdHeader } from "areas/shared/components";
import { DocumentUpload } from "areas/shared/controls";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import * as FormManager from 'fw/forms/form/FormManager';
import { TooltipCode } from 'areas/shared/consts';

class FinancialDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
            form: this.props.stepData,
            tooltips: this.props.stepInfo.tooltips
        };
    };

    updatePostData = (form, dirty) => {
        this.handleUploadsNotApplicableChange(form);
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    handleUploadsNotApplicableChange = (form) => {
        //check facilityUploadDocument
        if (form.facilityNotApplicable !== this.state.form.facilityNotApplicable) {
            this._facilityUpload.blankFile(0);
            form.facilityStorageToken = this._facilityUpload.state.storageToken;
            form.facilityFileName = this._facilityUpload.state.fileName;
        }
        //check currentYTDUploadDocument
        if (form.currentYTDNotApplicable !== this.state.form.currentYTDNotApplicable) {
            this._currentYTDUpload.blankFile(0);
            form.currentYTDStorageToken = this._currentYTDUpload.state.storageToken;
            form.currentYTDFileName = this._currentYTDUpload.state.fileName;
        }
        //check notesPayableUploadDocument
        if (form.notesPayableNotApplicable !== this.state.form.notesPayableNotApplicable) {
            this._notesPayableUpload.blankFile(0);
            form.notesPayableStorageToken = this._notesPayableUpload.state.storageToken;
            form.notesPayableFileName = this._notesPayableUpload.state.fileName;
        }
        //check occupationalLicenseUploadDocument
        if (form.occupationalLicenseNotApplicable !== this.state.form.occupationalLicenseNotApplicable) {
            this._occupationalLicenseUpload.blankFile(0);
            form.occupationalLicenseStorageToken = this._occupationalLicenseUpload.state.storageToken;
            form.occupationalLicenseFileName = this._occupationalLicenseUpload.state.fileName;
        }
        //check operatingPermitsUploadDocument
        if (form.operatingPermitsNotApplicable !== this.state.form.operatingPermitsNotApplicable) {
            this._operatingPermitsUpload.blankFile(0);
            form.operatingPermitsStorageToken = this._operatingPermitsUpload.state.storageToken;
            form.operatingPermitsFileName = this._operatingPermitsUpload.state.fileName;
        }
        //check ytdPayrollUploadDocument
        if (form.ytdPayrollNotApplicable !== this.state.form.ytdPayrollNotApplicable) {
            this._ytdPayrollUpload.blankFile(0);
            form.ytdPayrollStorageToken = this._ytdPayrollUpload.state.storageToken;
            form.ytdPayrollFileName = this._ytdPayrollUpload.state.fileName;
        }
        //check BondingCapacityProofUploadDocument
        if (form.bondingCapacityProofNotApplicable !== this.state.form.bondingCapacityProofNotApplicable) {
            this._bondingCapacityProofUpload.blankFile(0);
            form.bondingCapacityProofStorageToken = this._bondingCapacityProofUpload.state.storageToken;
            form.bondingCapacityProofFileName = this._bondingCapacityProofUpload.state.fileName;
        }
    }

    handleFacilityUploadChange = (file) => {
        let form = this.state.form;
        form.facilityStorageToken = file.storageToken;
        form.facilityFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleCurrentYTDUploadChange = (file) => {
        let form = this.state.form;
        form.currentYTDStorageToken = file.storageToken;
        form.currentYTDFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleNotesPayableUploadChange = (file) => {
        let form = this.state.form;
        form.notesPayableStorageToken = file.storageToken;
        form.notesPayableFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleOccupationalLicenseUploadChange = (file) => {
        let form = this.state.form;
        form.occupationalLicenseStorageToken = file.storageToken;
        form.occupationalLicenseFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleOperatingPermitsUploadChange = (file) => {
        let form = this.state.form;
        form.operatingPermitsStorageToken = file.storageToken;
        form.operatingPermitsFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleYTDPayrollUploadChange = (file) => {
        let form = this.state.form;
        form.ytdPayrollStorageToken = file.storageToken;
        form.ytdPayrollFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleBondingCapacityProofUploadChange = (file) => {
        let form = this.state.form;
        form.bondingCapacityProofStorageToken = file.storageToken;
        form.bondingCapacityProofFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleDescriptionChange = (value, index) => {
        let form = this.state.form;

        form.otherDocuments[index].documentDescription = value;
        this.updatePostData(form, true)
    };

    handleOtherDocumentRemove = (index) => {
        let form = this.state.form;

        form.otherDocuments[index].documentDescription = "";
    };

    handleUploadOtherDocumentChange = (file, index) => {
        let form = this.state.form;
        form.otherDocuments[index].storageToken = file.storageToken;
        form.otherDocuments[index].fileName = file.fileName;

        this.updatePostData(form, true)
    };

    addOtherDocument = () => {
        let form = this.state.form;
        form.otherDocuments.push({
            financialOtherDocumentId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    };

    handleRemoveOtherDocument = (i) => {
        let form = this.state.form;
        form.otherDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    buildFacilityUploadLabel() {
        let businessPremisesName = this.state.form.businessPremisesName !== null ?
            this.state.form.businessPremisesName.toUpperCase()
            : ""

        if (businessPremisesName === "OWNED")
            return "Security Deeds, Title Deed and Property Taxes";
        else if (businessPremisesName === "HOME-BASED")
            return "Security Deeds, Title Deed, Property Taxes and/or Lease Agreement";
        else // Default or LEASED
            return "Facility Lease or Title";
    }

    renderOtherDocuments = () => {
        return this.state.form.otherDocuments.map((item, index) => (
            <Row key={item.financialOtherDocumentId} style={{ marginBottom: 10 }}>
                <Col md={11}>
                    <DocumentUpload
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadOtherDocumentChange(file, index)}
                        onRemove={() => this.handleOtherDocumentRemove(index)}
                    />
                    <TextAreaBox
                        value={item.documentDescription}
                        placeholder="Briefly describe your Uploaded Financial Document here..."
                        maxLength={500}
                        onChange={value => this.handleDescriptionChange(value, index)}
                    />
                </Col>
                <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
					<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(index)} title="Remove Financial Document">
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
                </Col>
            </Row>
        ));
    };

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    render() {
        
        var checkBoxText = "Not Applicable to my Business";
        var notApplicableText = "Please provide a Letter of Explanation on a Corporate Letterhead that is signed and dated as to why it cannot be provided, and upload it in the field above";

        return (
            <div>
                <ContentBody>
                    <Form
                        onChange={this.updatePostData}
                        values={this.state.form}
                        unsavedChangesWarning={true}
                        disabled={this.props.stepInfo.readonly || this.props.stepInfo.isRenewal}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={12}>
                                        <h3 style={{ position: 'relative' }}>Financial Documents – <small> Please submit all required Financial Documents</small> <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                                        <hr />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label htmlFor="facilityUpload" tip={this.setTip(TooltipCode.FINANCE.FACUPLOAD)} required>{this.buildFacilityUploadLabel()}</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.facilityStorageToken}
                                                fileName={this.state.form.facilityFileName}
                                                onChange={this.handleFacilityUploadChange}
                                                ref={(c) => { this._facilityUpload = c; }}
                                            />
                                            <CheckBox inline name="facilityNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.facilityNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="currentYTDUpload" tip={this.setTip(TooltipCode.FINANCE.CURRYTDUPLOAD)} required>Current YTD financials</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.currentYTDStorageToken}
                                                fileName={this.state.form.currentYTDFileName}
                                                onChange={this.handleCurrentYTDUploadChange}
                                                ref={(c) => { this._currentYTDUpload = c; }}
                                            />
                                            <CheckBox inline name="currentYTDNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.currentYTDNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="notesPayableUpload" tip={this.setTip(TooltipCode.FINANCE.NPAYABLEUPLOAD)} required>Notes Payable</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.notesPayableStorageToken}
                                                fileName={this.state.form.notesPayableFileName}
                                                onChange={this.handleNotesPayableUploadChange}
                                                ref={(c) => { this._notesPayableUpload = c; }}
                                            />
                                            <CheckBox inline name="notesPayableNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.notesPayableNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="occupationalLicenseUpload" tip={this.setTip(TooltipCode.FINANCE.OCCLICUPLOAD)} required>Occupational License</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.occupationalLicenseStorageToken}
                                                fileName={this.state.form.occupationalLicenseFileName}
                                                onChange={this.handleOccupationalLicenseUploadChange}
                                                ref={(c) => { this._occupationalLicenseUpload = c; }}
                                            />
                                            <CheckBox inline name="occupationalLicenseNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.occupationalLicenseNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="operatingPermitsUpload" tip={this.setTip(TooltipCode.FINANCE.OPPERUPLOAD)} required>Operating Permits or License</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.operatingPermitsStorageToken}
                                                fileName={this.state.form.operatingPermitsFileName}
                                                onChange={this.handleOperatingPermitsUploadChange}
                                                ref={(c) => { this._operatingPermitsUpload = c; }}
                                            />
                                            <CheckBox inline name="operatingPermitsNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.operatingPermitsNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="ytdPayrollUpload" tip={this.setTip(TooltipCode.FINANCE.YDTPUPLOAD)} required>YTD Payroll - with Owners Name</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.ytdPayrollStorageToken}
                                                fileName={this.state.form.ytdPayrollFileName}
                                                onChange={this.handleYTDPayrollUploadChange}
                                                ref={(c) => { this._ytdPayrollUpload = c; }}
                                            />
                                            <CheckBox inline name="ytdPayrollNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.ytdPayrollNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                        <FormGroup>
                                            <Label htmlFor="bondingCapacityProofUpload" tip={this.setTip(TooltipCode.FINANCE.BONDINGCUPLOAD)} required>Proof of Bonding Capacity</Label>
                                            <DocumentUpload
                                                storageToken={this.state.form.bondingCapacityProofStorageToken}
                                                fileName={this.state.form.bondingCapacityProofFileName}
                                                onChange={this.handleBondingCapacityProofUploadChange}
                                                ref={(c) => { this._bondingCapacityProofUpload = c; }}
                                            />
                                            <CheckBox inline name="bondingCapacityProofNotApplicable" label={checkBoxText} />
                                            {this.state.form !== null && this.state.form.bondingCapacityProofNotApplicable ? (
                                                <div>{notApplicableText}</div>
                                            ) : null}
                                        </FormGroup>

                                    </Col>
                                    <Col md={1} />
                                    <Col md={6}>
                                        <label>&nbsp;</label>
                                        {this.state.form.otherDocuments != null &&
                                            this.state.form.otherDocuments.length > 0 && (
                                                <FormGroup>{this.renderOtherDocuments()}</FormGroup>
                                            )}
                                        {(this.state.form.otherDocuments == null || this.state.form.otherDocuments.length < 5) &&
											<Button type="button" bsStyle="link" onClick={this.addOtherDocument}>
                                                Add another Financial Document
											</Button>
										}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </ContentBody>
            </div>
        );
    }
}

export default FinancialDocuments;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/financialDocuments/FinancialDocuments.js